import { Box, Drawer } from '@mui/material'
import { BomItemName } from 'features/BillOfMaterials/components/BomItemName'
import { RowThumbnailButton } from 'features/BillOfMaterials/components/BomItemThumbnailButton'
import { ProjectStatusSelector } from 'features/BillOfMaterials/components/ProjectStatus/ProjectStatus'
import { ProjectReferenceButton } from 'features/BillOfMaterials/ProjectHeader/ProjectReferenceInput'
import { ProjectRequestedDeliveryDate } from 'features/BillOfMaterials/ProjectHeader/ProjectRequestedDeliveryDate'
import { BomItemPointer } from 'model/Project/BomItemPointer'
import { BomItemType } from 'model/Project/BoMItemRow'
import { useMemo } from 'react'
import { BomItemAttachmentDetails } from './BomItemDetails/Attachments/BomItemAttachmentDetails'
import { useBomItemDetailsDrawerStyles } from './BomItemDetailsDrawer.styles'
import { BomItemDetailsDrawerHeader } from './BomItemDetailsDrawerHeader'

type Props = {
  bomItemPointer: BomItemPointer
  open: boolean
  onClose: () => void
  filesToUpload?: File[]
  resizer?: React.ReactNode
  containerRef?: React.RefObject<HTMLDivElement>
}

export const BomItemDetailsBuyerView = (props: Props) => {
  const { classes } = useBomItemDetailsDrawerStyles()

  const BomComponent = useMemo(() => {
    switch (props.bomItemPointer?.type) {
      case BomItemType.partType:
      case BomItemType.assemblyType:
      case BomItemType.partInstance:
      case BomItemType.assemblyInstance: {
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              gap: (theme) => theme.spacing(2),
            }}
          >
            <RowThumbnailButton
              bomItemPointer={props.bomItemPointer}
              size="large"
              pictureClassName={classes.picture}
              dontRenderEmpty
            />
            <BomItemName
              asLabel
              valueLabelProps={{
                label: '',
              }}
              bomItemPointer={props.bomItemPointer}
            />
          </Box>
        )
      }
      case BomItemType.project: {
        return (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              gap: (theme) => theme.spacing(2),
              width: '100%',
            }}
          >
            <ProjectStatusSelector bomItemPointer={props.bomItemPointer} />
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                alignItems: 'center',
                padding: '0 1rem 0 0',
              }}
            >
              <ProjectReferenceButton />
              <ProjectRequestedDeliveryDate />
            </div>
          </Box>
        )
      }
      default: {
        return null
      }
    }
  }, [classes.picture, props.bomItemPointer])

  return (
    <Drawer
      open={props.open}
      onClose={props.onClose}
      variant="persistent"
      anchor="right"
      id="financial-details-drawer"
    >
      {props.resizer}
      <div
        ref={props.containerRef}
        className={classes.container}
        style={{
          paddingBottom: 0,
          overflowY: 'auto',
        }}
      >
        <div
          className={classes.header}
          style={{
            width: '100%',
          }}
        >
          <BomItemDetailsDrawerHeader
            bomItemPointer={props.bomItemPointer}
            handleClose={props.onClose}
          />
        </div>
        <div className={classes.bomItemDescription}>
          {BomComponent}
          {/* </Box> */}
        </div>
        <BomItemAttachmentDetails
          bomItemPointer={props.bomItemPointer}
          initialFilesToUpload={props.filesToUpload}
          variant="list"
        />
      </div>
    </Drawer>
  )
}
